var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowerpointLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 88.024445 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,204 H 250.91 V 0 H 0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.48159 0 0 -.49501 -16.645 93.371)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(211.32 43.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0m-0.01 0h-72.24v15.083h56.333v7h-56.333v11.833h56.333v7h-56.333v19.453c4.539-5.322 11.289-8.702 18.833-8.702 13.669 0 24.749 11.081 24.749 24.749h-24.749v24.749c-7.544 0-14.294-3.38-18.833-8.702v27.537h72.25zm0.01 126h-72.25v18.874l-104.5-18.131v-137.49l104.5-18.131v22.876h72.25c3.309 0 6 2.691 6 6v120c0 3.309-2.691 6-6 6",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(161.74 148.42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -24.749 H 24.749 C 24.749,-11.081 13.669,0 0,0",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.788 102.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c4.169-0.32 8.241-1.099 10.773 3.223 1.914 3.261 1.753 9.22-0.467 11.726-2.871 3.24-6.58 2.778-10.306 2.188zm-0.294-30.68h-10.467v58.422c8.075 0 16.109 0.227 24.113-0.153 2.104-0.1 4.547-1.664 6.1-3.268 5.944-6.137 5.945-13.782 4.169-21.407-1.583-6.791-5.964-11.569-12.869-13.249-3.44-0.837-7.121-0.683-11.046-1.006z",
    fill: "#051f42",
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerpointLogo);
export default __webpack_public_path__ + "static/media/powerpoint-logo.cb063b84933996a9ae03e5a0978e2a2e.svg";
export { ForwardRef as ReactComponent };